import React from "react";
import { Box, Typography } from "@mui/material";

const Error = ({ error }: { error?: Error }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100vh"
    textAlign="center"
  >
    <Typography variant="h5" fontWeight="bold">
      {error?.message ?? "Something went wrong"}
    </Typography>
  </Box>
);

export default Error;
